import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { ServiceBase } from "../../shared/base/service-base";
import { SyllabusImage } from "./syllabus-image";
import { AuthService } from "../../core/auth.service";

@Injectable()
export class SyllabusImageService extends ServiceBase<SyllabusImage> {
  constructor(
    db: AngularFireDatabase,
    private auth: AuthService
  ) {
    super(db, '/syllabus-images');
  }

  push(value: any) {
    return super.push(Object.assign(new SyllabusImage(), {
      owner: this.auth.auth.uid
    }, value));
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/shared/syllabus-image.service.ts